// extracted by mini-css-extract-plugin
module.exports = {"topbar":"_2Q5mOP3","menuPlusLogoContainer":"s6oyvu5","rightContainer":"_36_MwDI","menuButton":"_2XQiTWl","logo":"_2fDRe1y","phone":"_3TawoEq","whatsappIcon":"_1JsUMaf"};